/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
// @ts-ignore
import type * as Types from '../../../../../packages/graphql/index';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type LoginV2MutationVariables = Exact<{
  token: string;
}>;


export type LoginV2Mutation = { loginV2: { token_type: string, access_token: string, refresh_token: string, expires_in: number, sendbird_access_token: string | null } | null };


export const LoginV2Document = /*#__PURE__*/ gql`
    mutation LoginV2($token: String!) {
  loginV2(token: $token) {
    token_type
    access_token
    refresh_token
    expires_in
    sendbird_access_token
  }
}
    `;
export type LoginV2MutationFn = Apollo.MutationFunction<LoginV2Mutation, LoginV2MutationVariables>;

/**
 * __useLoginV2Mutation__
 *
 * To run a mutation, you first call `useLoginV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginV2Mutation, { data, loading, error }] = useLoginV2Mutation({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useLoginV2Mutation(baseOptions?: Apollo.MutationHookOptions<LoginV2Mutation, LoginV2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LoginV2Mutation, LoginV2MutationVariables>(LoginV2Document, options);
      }
export type LoginV2MutationHookResult = ReturnType<typeof useLoginV2Mutation>;
export type LoginV2MutationResult = Apollo.MutationResult<LoginV2Mutation>;
export type LoginV2MutationOptions = Apollo.BaseMutationOptions<LoginV2Mutation, LoginV2MutationVariables>;